export function buildAgentReviewUpdate(review = {}, selectedIds = []) {
    const selected = new Set(selectedIds)
    const payload = {
        expected_version: review.base_version,
        reason: "Melhorias aceitas na verificação com IA"
    }
    ;(review.suggestions || []).filter(item => selected.has(item.id)).forEach(suggestion => {
        if (suggestion.section === "identity") Object.assign(payload, suggestion.proposed_value)
        else payload[suggestion.section] = suggestion.proposed_value
    })
    return payload
}
